export enum LocalStorageKeys {
  FORM_OWNER_TYPE = 'FORM_OWNER_TYPE',
  FORM_OWNER_NAME = 'FORM_OWNER_NAME',
  BANNER_HIDDEN = 'BANNER_HIDDEN',
}
